import { UiKitRoot } from '@cian/ui-kit';
import { hydrateRoot } from 'react-dom/client';

import { Application } from 'shared/containers/App';
import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';

interface IDependencies {
  store: TReduxStore;
  context: IApplicationContext;
}

export function renderApplication(dependencies: IDependencies): void {
  const { store, context } = dependencies;
  const {
    config,
    custom: { initialDeviceType },
  } = context;

  const projectName = config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  hydrateRoot(
    rootElement,
    <UiKitRoot deviceType={initialDeviceType} useStaticDeviceType>
      <Application context={context} reduxStore={store} />
    </UiKitRoot>,
  );
}
